import {Controller} from "stimulus";
import {formatDuration} from "src/common/duration";

export default class DelayedDisplayController extends Controller<HTMLElement> {
  static targets = ["original", "replacement", "countdown"];
  static values = {
    delay: {type: Number, default: 5000},
  };

  declare originalTarget: HTMLElement;
  declare replacementTarget: HTMLElement;
  declare countdownTarget: HTMLElement;

  declare hasCountdownTarget: boolean;
  declare delayValue: number;

  declare startTime: number;
  declare finishTime: number;
  declare timeout: any;
  declare interval: any;

  connect() {
    this.originalTarget.style.display = "";
    this.replacementTarget.style.display = "none";

    this.timeout = setTimeout(() => {
      this.originalTarget.style.display = "none";
      this.replacementTarget.style.display = "";

      clearInterval(this.interval);
    }, this.delayValue);

    this.startTime = Date.now();
    this.finishTime = this.startTime + this.delayValue;

    this.updateCountdown();
    this.interval = setInterval(() => this.updateCountdown(), 1000);
  }

  disconnect() {
    clearTimeout(this.timeout);
    clearInterval(this.interval);
  }

  updateCountdown() {
    const timeRemaining = this.finishTime - Date.now();
    const remainingSeconds = Math.ceil(timeRemaining / 1000);

    this.originalTarget.dataset.remainingSeconds = remainingSeconds.toString();

    if (this.hasCountdownTarget) {
      this.countdownTarget.textContent = formatDuration(remainingSeconds, "long");
    }
  }
}
